// Imported chart caches can be empty or stale. Source ranges are authoritative
// after workbook formulas have recalculated, including after an input edit.
export function refreshSpreadsheetCharts(charts, rows) {
  if (!Array.isArray(charts)) return charts;
  let changed = false;
  const next = charts.map(chart => {
    const range = chart.sourceRange;
    if (!range || !['r1', 'r2', 'c1', 'c2'].every(key => Number.isInteger(range[key]))
      || range.r1 < 0 || range.c1 < 0 || range.r2 < range.r1 || range.c2 <= range.c1
      || range.r2 >= rows.length || range.c2 >= (rows[range.r1]?.length || 0)
      || (range.r2 - range.r1 + 1) * (range.c2 - range.c1 + 1) > 10000) return chart;
    const start = range.headerRow === false ? range.r1 : range.r1 + 1;
    const count = chart.type === 'pie' ? 1 : range.c2 - range.c1;
    const series = Array.from({ length: count }, (_, index) => {
      const old = chart.series?.[index] || {};
      const column = range.c1 + index + 1;
      const name = range.headerRow === false ? old.name : rows[range.r1]?.[column]?.v;
      const data = [];
      for (let row = start; row <= range.r2; row += 1) {
        const raw = rows[row]?.[column]?.v;
        // Missing/error results must not masquerade as measured zeros.
        if (raw == null || raw === '' || typeof raw === 'boolean') continue;
        const y = typeof raw === 'number' ? raw : Number(String(raw).replace(/,/g, ''));
        if (!Number.isFinite(y)) continue;
        data.push({ x: String(rows[row]?.[range.c1]?.v ?? ''), y });
      }
      return { ...old, name: String(name || old.name || `Series ${index + 1}`), data };
    });
    if (JSON.stringify(series) === JSON.stringify(chart.series)) return chart;
    changed = true;
    return { ...chart, series };
  });
  return changed ? next : charts;
}
